import { useCallback } from 'react'
import { FormDialog } from 'components/dialog/form'

import { usePostGroup, GroupResult } from 'interface/user/group'
import { GroupForm, useGroupForm } from '../form'

type AddGroupDialogProps = {
  onAddGroup: (group: GroupResult) => void
  onClose: () => void
}
export const AddGroupDialog = ({
  onAddGroup,
  onClose,
}: AddGroupDialogProps) => {
	const onPosted = useCallback(
		(result: GroupResult) => {
      onAddGroup(result)
      onClose()
		},
		[onAddGroup, onClose]
	)
  const [postState, postGroup] = usePostGroup({ onPosted })
  const form = useGroupForm({ onSubmit: postGroup })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="グループを追加"
      isLoading={postState.posting}
      error={postState.error}
      body={<GroupForm {...form}/>}
      isValid={form.formState.isValid}
      submitLabel='登録'
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
